package org.multiplatform.kotfolio.layout

import kotlinx.browser.document

data class PageProperties(
    var title: String? = "Multiplatform Developer",
    var description: String? = "A versatile Multiplatform Developer specializing in building high-quality applications for Android, iOS, Web, and Backend systems. Proficient in modern multiplatform tools and technologies, including Kotlin Multiplatform (KMM), Kotlin/JS, and Kobweb, to create shared, maintainable, and efficient codebases. Experienced in crafting intuitive user interfaces and seamless user experiences while leveraging platform-specific optimizations. Skilled in backend development and API integration, ensuring secure and scalable system architecture. Dedicated to delivering innovative solutions and keeping pace with the latest trends in multiplatform and Kotlin-based development."
)

fun updatePageProperties(
    block: PageProperties.() -> Unit
) {
    val pageProperties = PageProperties()
    pageProperties.block()
    pageProperties.apply {
        title?.let {
            document.title = it
        }

        description?.let {
            document.querySelector("meta[name=\"description\"]")
                ?.setAttribute("content", it)
        }
    }
}

data class BlogProperties(
    var title: String,
    var subTitle: String
)